import { isNil } from 'lodash-es'
import { Locale, Translation } from 'locale'

export function formatDuration(durationMinutes: number | null) {
  if (isNil(durationMinutes)) {
    return Locale.translate(Translation.SC_AS_RFQ)
  } else if (durationMinutes === 0) {
    return Locale.translate(Translation.SC_LAST_LOOK)
  } else {
    const hours = Math.floor(durationMinutes / 60)
    const minutes = durationMinutes % 60
    const hoursString = hours === 0 ? '' : `${Locale.translate(Translation.SC_DURATION_HOURS, { duration: hours })} `
    const minutesString = minutes === 0 ? '' : Locale.translate(Translation.SC_DURATION_MINUTES, { duration: minutes })
    return `${hoursString}${minutesString}`
  }
}
